(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-progress-bar-custom"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__ShippingProgressDefined) return;
    window.__ShippingProgressDefined = true;

    class ShippingProgress {
      constructor(el) {
        this.el = el;
        this.bar = el.querySelector('.shipping-progress__bar');
        this.track = el.querySelector('.shipping-progress__track');
        this.message = el.querySelector('.shipping-progress__message');
        this.milestone = el.querySelector('.shipping-progress__milestone');
        this.giftPicker = el.querySelector('.shipping-progress__gift-picker');

        this.preShippingMessage = el.dataset.preMessage;
        this.postShippingMessage = el.dataset.postMessage;
        this.preGiftMessage = el.dataset.preGiftMessage;
        this.postGiftMessage = el.dataset.postGiftMessage;
        this.moneyFormat = el.dataset.moneyFormat;
        this.barColor = el.dataset.barColor;
        this.barFullColor = el.dataset.barFullColor;
        this.giftBarColor = el.dataset.giftBarColor;
        this.giftBarFullColor = el.dataset.giftBarFullColor;
        this.giftCollectionHandle = el.dataset.giftCollection || 'gift-with-purchase';
        this._syncingGift = false;
        this._giftProducts = null;
        this._allGiftVariantIds = [];
        this._selectedVariantId = null;

        this.currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active)
          ? window.Shopify.currency.active
          : el.dataset.currency;

        var shippingThresholds = {
          AUD: parseInt(el.dataset.thresholdAud || 0),
          USD: parseInt(el.dataset.thresholdUsd || 0),
          EUR: parseInt(el.dataset.thresholdEur || 0),
          GBP: parseInt(el.dataset.thresholdGbp || 0)
        };

        var giftThresholds = {
          AUD: parseInt(el.dataset.giftThresholdAud || 0),
          USD: parseInt(el.dataset.giftThresholdUsd || 0),
          EUR: parseInt(el.dataset.giftThresholdEur || 0),
          GBP: parseInt(el.dataset.giftThresholdGbp || 0)
        };

        this.shippingThreshold = shippingThresholds[this.currency]
          || parseInt(el.dataset.thresholdDefault || 0)
          || Object.values(shippingThresholds).find(function(v) { return v > 0; })
          || 0;

        this.giftThreshold = giftThresholds[this.currency]
          || parseInt(el.dataset.giftThresholdDefault || 0)
          || 0;

        this.observe();
        this.refresh();
      }

      async refresh() {
        try {
          var res = await fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } });
          var cart = await res.json();
          this.render(cart.total_price);
          await this.syncGift(cart);
        } catch (_) {}
      }

      render(totalCents) {
        var hasGift = this.giftThreshold > 0;
        var maxThreshold = hasGift ? this.giftThreshold : this.shippingThreshold;
        if (!maxThreshold) return;

        var shippingReached = totalCents >= this.shippingThreshold;
        var giftReached = hasGift && totalCents >= this.giftThreshold;
        var progress = Math.min(100, Math.round((totalCents / maxThreshold) * 100));

        this.bar.style.width = progress + '%';
        this.track.setAttribute('aria-valuenow', progress);

        var barColor;
        if (giftReached) {
          barColor = this.giftBarFullColor || this.barFullColor;
        } else if (shippingReached && hasGift) {
          barColor = this.giftBarColor || this.barColor;
        } else if (shippingReached) {
          barColor = this.barFullColor;
        } else {
          barColor = this.barColor;
        }

        if (barColor) {
          this.track.style.background = 'linear-gradient(to right, ' + barColor + ' ' + progress + '%, rgba(0,0,0,0.1) ' + progress + '%)';
          this.bar.style.backgroundColor = barColor;
        }

        if (this.milestone && hasGift && this.shippingThreshold > 0) {
          var milestonePos = Math.round((this.shippingThreshold / this.giftThreshold) * 100);
          this.milestone.style.left = milestonePos + '%';
          this.milestone.classList.toggle('shipping-progress__milestone--reached', shippingReached);
        }

        var msg = '';
        if (giftReached) {
          msg = this.postGiftMessage;
        } else if (shippingReached && hasGift) {
          var remaining = this.giftThreshold - totalCents;
          msg = (this.preGiftMessage || '').replace('[remainingForGiftFormatted]', this.formatMoney(remaining));
        } else if (shippingReached) {
          msg = this.postShippingMessage;
        } else {
          var remainingShipping = this.shippingThreshold - totalCents;
          msg = (this.preShippingMessage || '').replace('[remainingForGoalFormatted]', this.formatMoney(remainingShipping));
        }

        this.message.innerHTML = msg;
        this.el.classList.toggle('shipping-progress--complete', shippingReached);
        this.el.classList.toggle('shipping-progress--gift-complete', giftReached);
      }

      async fetchGiftProducts() {
        if (this._giftProducts) return this._giftProducts;
        try {
          var res = await fetch('/collections/' + this.giftCollectionHandle + '/products.json?limit=6');
          if (!res.ok) return [];
          var data = await res.json();
          this._giftProducts = data.products || [];
          var self = this;
          this._allGiftVariantIds = [];
          this._giftProducts.forEach(function(p) {
            p.variants.forEach(function(v) {
              self._allGiftVariantIds.push(v.id);
            });
          });
          return this._giftProducts;
        } catch (_) {
          return [];
        }
      }

      renderGiftPicker(products, selectedVariantId) {
        if (!this.giftPicker) return;
        if (!products || !products.length) {
          this.giftPicker.style.display = 'none';
          return;
        }

        var self = this;
        var startOpen = !selectedVariantId;

        var selectedTitle = '';
        if (selectedVariantId) {
          products.forEach(function(p) {
            p.variants.forEach(function(v) {
              if (v.id === selectedVariantId) {
                selectedTitle = p.title.split(' – ')[0].split(' | ')[0];
                if (selectedTitle.length > 28) selectedTitle = selectedTitle.slice(0, 25) + '…';
              }
            });
          });
        }

        var toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'shipping-progress__gift-toggle';

        var label = document.createElement('span');
        label.className = 'shipping-progress__gift-toggle-label';
        if (selectedVariantId) {
          label.innerHTML = '🎁 ' + selectedTitle + ' &nbsp;<span class="shipping-progress__gift-change">Change</span>';
        } else {
          label.textContent = '🎁 Choose your free gift';
        }

        var chevron = document.createElement('span');
        chevron.className = 'shipping-progress__gift-chevron';
        chevron.setAttribute('aria-hidden', 'true');
        chevron.textContent = startOpen ? '✕' : '▾';

        toggle.appendChild(label);
        toggle.appendChild(chevron);

        var body = document.createElement('div');
        body.className = 'shipping-progress__gift-picker-body';

        var options = document.createElement('div');
        options.className = 'shipping-progress__gift-options';

        products.forEach(function(product) {
          var variant = product.variants.find(function(v) { return v.available; }) || product.variants[0];
          if (!variant) return;

          var isSelected = selectedVariantId === variant.id;
          var option = document.createElement('div');
          option.className = 'shipping-progress__gift-option' + (isSelected ? ' shipping-progress__gift-option--selected' : '');
          option.dataset.variantId = variant.id;

          var img = document.createElement('img');
          img.className = 'shipping-progress__gift-option-image';
          var imgSrc = (product.images && product.images[0]) ? product.images[0].src : '';
          img.src = imgSrc ? imgSrc.replace(/(\.[^\.(]+(\?.*)?)$/, function(m, ext) { return '_200x200' + ext; }) : '';
          img.alt = product.title;
          img.loading = 'lazy';

          var name = document.createElement('span');
          name.className = 'shipping-progress__gift-option-name';
          var shortTitle = product.title.split(' – ')[0].split(' | ')[0];
          if (shortTitle.length > 28) shortTitle = shortTitle.slice(0, 25) + '…';
          name.textContent = shortTitle;

          var btn = document.createElement('button');
          btn.className = 'shipping-progress__gift-option-btn';
          btn.type = 'button';
          btn.textContent = isSelected ? 'Selected' : 'Choose';
          if (!isSelected) {
            btn.addEventListener('click', function() { self.chooseGift(variant.id); });
          }

          option.appendChild(img);
          option.appendChild(name);
          option.appendChild(btn);
          options.appendChild(option);
        });

        body.appendChild(options);

        this.giftPicker.innerHTML = '';
        this.giftPicker.appendChild(toggle);
        this.giftPicker.appendChild(body);
        this.giftPicker.style.display = '';

        if (startOpen) {
          this.giftPicker.classList.add('shipping-progress__gift-picker--open');
        } else {
          this.giftPicker.classList.remove('shipping-progress__gift-picker--open');
        }

        toggle.addEventListener('click', function() {
          self.giftPicker.classList.toggle('shipping-progress__gift-picker--open');
          chevron.textContent = self.giftPicker.classList.contains('shipping-progress__gift-picker--open') ? '✕' : '▾';
        });
      }

      async chooseGift(variantId) {
        if (this._syncingGift) return;
        this._syncingGift = true;
        try {
          var res = await fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } });
          var cart = await res.json();
          var allIds = this._allGiftVariantIds;
          var currentGifts = cart.items.filter(function(item) { return allIds.includes(item.variant_id); });

          if (currentGifts.length) {
            var updates = {};
            currentGifts.forEach(function(item) { updates[String(item.variant_id)] = 0; });
            await fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ updates: updates })
            });
          }

          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 })
          });

          this._selectedVariantId = variantId;
          await this.refreshCartUI();
          if (this._giftProducts) {
            this.renderGiftPicker(this._giftProducts, this._selectedVariantId);
          }
        } catch (_) {}
        this._syncingGift = false;
      }

      async syncGift(cart) {
        if (this._syncingGift || !this.giftThreshold) return;
        this._syncingGift = true;
        try {
          var giftReached = cart.total_price >= this.giftThreshold;
          var products = await this.fetchGiftProducts();

          if (!products || !products.length) {
            this._syncingGift = false;
            return;
          }

          var allIds = this._allGiftVariantIds;
        var giftsInCart = (cart.items || []).filter(function(item) { return allIds.includes(item.variant_id); });

          if (!giftReached) {
            if (giftsInCart.length) {
              var updates = {};
              giftsInCart.forEach(function(item) { updates[String(item.variant_id)] = 0; });
              await fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ updates: updates })
              });
              await this.refreshCartUI();
            }
            this._selectedVariantId = null;
            if (this.giftPicker) this.giftPicker.style.display = 'none';
          } else {
            if (giftsInCart.length) {
              this._selectedVariantId = giftsInCart[0].variant_id;
            }
            this.renderGiftPicker(products, this._selectedVariantId);
          }
        } catch (_) {}
        this._syncingGift = false;
      }

      async refreshCartUI() {
        try {
          var drawerRes = await fetch('/cart?section_id=cart-drawer');
          var drawerText = await drawerRes.text();
          var doc = new DOMParser().parseFromString(drawerText, 'text/html');
          var selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          selectors.forEach(function(sel) {
            var target = document.querySelector(sel);
            var source = doc.querySelector(sel);
            if (target && source) target.replaceWith(source);
          });

          var bubbleRes = await fetch('/?sections=cart-icon-bubble');
          var bubbleData = await bubbleRes.json();
          if (bubbleData['cart-icon-bubble']) {
            var bubbleEl = document.getElementById('shopify-section-cart-icon-bubble');
            if (bubbleEl) bubbleEl.outerHTML = bubbleData['cart-icon-bubble'];
          }

          initAll();
        } catch (_) {}
      }

      formatMoney(cents) {
        var amount = (cents / 100).toFixed(2);
        var amountNoDecimals = String(Math.round(cents / 100));
        return this.moneyFormat
          .replace(/\{\{\s*amount\s*\}\}/g, amount)
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
          .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amountNoDecimals);
      }

      observe() {
        var self = this;
        var targets = [
          '#CartDrawer-CartItems',
          '#CartItems',
          'cart-items',
          'cart-drawer-items'
        ].map(function(s) { return document.querySelector(s); }).filter(Boolean);

        if (!targets.length) return;
        var observer = new MutationObserver(function() { self.refresh(); });
        targets.forEach(function(t) { observer.observe(t, { childList: true, subtree: true, characterData: true }); });
      }
    }

    function initAll() {
      document.querySelectorAll('[data-shipping-progress]').forEach(function(el) {
        if (el.__spInit) return;
        el.__spInit = true;
        new ShippingProgress(el);
      });
    }

    window.__ShippingProgressInit = initAll;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
